import { AppAreaConfig } from '@/funnels/@types'
import fastingFemale from './female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-ayurveda-fwf',
	landing: {
		ids: ['loader-f-ayurveda'],
		route: {
			path: '/ayurveda-f',
			name: 'female-ayurveda-fwf-funnel',
		},
	},
	funnel: {
		id: 'ob-female-ayurveda-fasting-fwf',
		route: {
			path: '/ayurveda-f/ob/:page*',
			name: 'female-ayurveda-fwf',
		},
		slug: 'female-ayurveda-fwf',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: fastingFemale,
				page: 'target-zones',
			},
		},
	},
}

export default appAreaConfig
